/**
 * formatRelativeTime — compact human-friendly relative timestamps for
 * the "Recent" dropdown and the Community Pulse ticker.
 *
 *   <1m  -> "just now"
 *   <1h  -> "12m ago"
 *   <24h -> "3h ago"
 *   <7d  -> "2d ago" (or "yesterday" at exactly 1 day)
 *   else -> "Mar 14"  (en-CA short date — never goes home to a parent)
 *
 * Accepts ISO strings, Date instances, or numeric epoch ms.
 */
export const formatRelativeTime = (input) => {
  if (!input) return "";
  let ts;
  if (typeof input === "string") ts = Date.parse(input);
  else if (input instanceof Date) ts = input.getTime();
  else ts = Number(input);
  if (!Number.isFinite(ts)) return "";
  const diffSec = Math.max(0, (Date.now() - ts) / 1000);
  if (diffSec < 60) return "just now";
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;
  const diffDay = Math.floor(diffHr / 24);
  if (diffDay === 1) return "yesterday";
  if (diffDay < 7) return `${diffDay}d ago`;
  try {
    return new Date(ts).toLocaleDateString("en-CA", {
      month: "short",
      day: "numeric",
    });
  } catch {
    return "";
  }
};
